export default {
  email: [
    {
      key: "required",
      message: "Mejladress är obligatoriskt.",
      id: "emailRequired",
    },
    {
      key: "emailFormat",
      message: "Felaktigt format på mejladressen.",
      id: "emailFormat",
    },
    {
      key: "maxLength",
      message: "Mejladressen får inte vara mer än 100 tecken långt.",
      id: "emailLength",
    },
  ],
};
